/**
 * Created by Szabó István György on 2019.10.15.
 */

export default function (app) {
	app.directive('keyEnter',  () => {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: (scope, elem, attrs) => {
                elem.bind("keydown keypress", (event) => {
                    if (event.which === 13) {
                        scope.$apply(function () {
                            scope.$eval(attrs.keyEnter);
                            // erre a blur-re azért van szükség, mert hiába kerül rá pl ng-invalid
                            // nem jelenik meg a piros keret és a validálási hibaüzenet
                            elem[0].blur();
                            // ez meg ha folytatni szeretné az inputban a szöveg módosítást egyből gépelhez megjelenik a kurzor
                            elem[0].focus();
                        });

                        event.preventDefault();
                    }
                });
            }
        }
    });
};
